import {Users} from 'lucide-react';
import {URLS} from "@/lib/urls";
import {useNavigate} from "react-router-dom";
import RenderIf from "@/components/render-if";
import {Button} from "antd";


export default function AccountSelector({currentUser, children, onSelectAccount, isLoading}) {
    const navigate = useNavigate();

    const getInitials = (firstname, lastname) => {
        return `${firstname.charAt(0)}${lastname.charAt(0)}`;
    };

    const getColorClass = (index) => {
        const colors = ['bg-gradient-to-br from-blue-500 to-blue-600', 'bg-gradient-to-br from-emerald-500 to-emerald-600', 'bg-gradient-to-br from-amber-500 to-amber-600', 'bg-gradient-to-br from-rose-500 to-rose-600', 'bg-gradient-to-br from-violet-500 to-violet-600', 'bg-gradient-to-br from-cyan-500 to-cyan-600',];
        return colors[index % colors.length];
    };

    return (<div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-slate-100" dir="rtl">
        <div className="container mx-auto px-4 py-8 md:py-16">
            <div className="max-w-4xl mx-auto">
                <div className="text-center mb-12">
                    <div
                        className="inline-flex items-center justify-center w-20 h-20 bg-white rounded-2xl shadow-lg mb-6">
                        <Users className="w-10 h-10 text-blue-600"/>
                    </div>
                    <h1 className="text-3xl md:text-4xl font-bold   mb-3">
                        انتخاب حساب کاربری
                    </h1>
                    <p className="  text-lg">
                        برای ورود به سامانه، حساب کاربری مورد نظر خود را انتخاب کنید
                    </p>
                </div>

                <div className="grid gap-6 md:grid-cols-2">


                    {children?.data?.data?.map((child, index) => (<div key={child.id} className="group">
                        <div
                            className="bg-white rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-300 p-8 border-2 border-transparent hover:border-emerald-500 cursor-pointer transform hover:-translate-y-1">
                            <div className="flex flex-col items-center">
                                <div className="relative mb-6">

                                    <div
                                        className={`w-24 h-24 ${getColorClass(index)} rounded-2xl flex items-center justify-center shadow-lg`}>
                                        <RenderIf condition={child?.avatar}
                                                  falsyElement={<span className="text-3xl font-bold text-white">
                          {getInitials(child.firstname, child.lastname)}
                        </span>}>
                                            <img src={child.avatar} alt="abc" className={'w-24 h-24 rounded-2xl'}/>
                                        </RenderIf>

                                    </div>

                                    <div
                                        className="absolute -bottom-2 -right-2 w-8 h-8 bg-emerald-500 rounded-full flex items-center justify-center shadow-md">
                                        <svg className="w-5 h-5 text-white" fill="currentColor"
                                             viewBox="0 0 20 20">
                                            <path fillRule="evenodd"
                                                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                                                  clipRule="evenodd"/>
                                        </svg>
                                    </div>

                                </div>

                                <h3 className="text-2xl font-bold   mb-2">
                                    {child.firstname} {child.lastname}
                                </h3>

                                <span
                                    className="inline-flex items-center px-4 py-1.5 rounded-full text-sm font-medium bg-slate-100   mb-6">
                      <RenderIf condition={child?.parent}
                                falsyElement={<span className="text-sm text-blue-600">حساب اصلی (‌والد)</span>}>
                          فرزند
                      </RenderIf>
                    </span>

                                <Button loading={isLoading}
                                        size={'large'}
                                        variant={'solid'}
                                        color={'cyan'}
                                        className={'block w-full'}
                                        onClick={() => onSelectAccount(child.id, false)}
                                    // className="w-full bg-gradient-to-l from-emerald-600 to-emerald-700 text-white font-semibold py-4 px-8 rounded-xl hover:from-emerald-700 hover:to-emerald-800 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105"
                                >
                                    ورود به حساب کاربری
                                </Button>
                            </div>
                        </div>
                    </div>))}
                </div>

                <div className="mt-8 text-center">
                    <button
                        onClick={() => navigate(URLS.auth.logout)}
                        className="  hover:  font-medium transition-colors duration-200 inline-flex items-center gap-2">
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                  d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"/>
                        </svg>
                        خروج از حساب کاربری
                    </button>
                </div>
            </div>
        </div>
    </div>);
}
